import { 
  Avatar, 
  Button, 
  Grid, 
  IconButton, 
  Typography, 
  useMediaQuery,
  useTheme
} from '@mui/material';
import React from 'react'
import { 
  ExpandableTopAppBar,
  StyledToolbar, 
  UserProfilePictureButton 
} from './styled';
import MenuIcon from '@mui/icons-material/Menu';
import gtmTrackButtonClick from '../../libs/gtmTrackButtonClick';
import { useAuth0 } from '@auth0/auth0-react';
import useCurrentUserInfo from '../../hooks/useCurrentUserInfo';
import { useNavigate } from 'react-router-dom';
import { AvatarContainer } from '../../containers/UserProfile/styled';

function TopAppBar({
  drawerOpen,
  drawerWidth,
  handleDrawerToggle,
}) {

  const { isAuthenticated } = useAuth0();
  const userInfo = useCurrentUserInfo();
  const theme = useTheme();

	const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <ExpandableTopAppBar
      position="fixed" 
      open={drawerOpen} 
      drawerWidth={drawerWidth}
      elevation={0} 
      isAuthenticated={isAuthenticated}
    >
      <StyledToolbar>
        <AvatarContainer container sx={{ display: 'flex', flex: '2'}}>
          <Avatar 
            sx={{margin: '1rem'}} 
            alt={userInfo?.name} 
            src={userInfo?.picture ?? 'https://res.cloudinary.com/djrbfvpit/image/upload/v1737325651/CloudSous%20Assets/saaschowlogo2_xf1j79.png'} 
          />
          <Typography>{userInfo?.name ?? "Username Person"}</Typography>
        </AvatarContainer>
          <IconButton
            color='default'
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            sx={{
              ...(drawerOpen && { display: 'none' }),
              display: isMobile ? 'block' : 'none',
            }}
          >
            <MenuIcon sx={{color: `${theme.palette.whites.main}`, fontSize: '2.5rem'}} />
          </IconButton>
      </StyledToolbar>
    </ExpandableTopAppBar>
  );
};

export default TopAppBar;